<div class="kb-page">

  <!-- ── Header ───────────────────────────────────────────────────── -->
  <div class="kb-header">
    <div class="kb-header-left">

      <!-- Date navigator -->
      <div class="kb-date-nav" [class.kb-date-nav--today]="isToday" [class.kb-date-nav--future]="isFuture">
        <button class="kb-nav-arrow" (click)="shiftDate(-1)" title="Previous day">
          <i class="pi pi-chevron-left"></i>
        </button>

        <label class="kb-date-label-wrap" title="Click to pick a date">
          <div class="kb-date-label-main">{{ selectedDateLabel }}</div>
          <div class="kb-date-label-sub">{{ selectedDateSub }}</div>
          <input
            type="date"
            class="kb-date-input-hidden"
            [(ngModel)]="selectedDate"
            (change)="onDateChange()"
          />
        </label>

        <button class="kb-nav-arrow" (click)="shiftDate(1)" title="Next day">
          <i class="pi pi-chevron-right"></i>
        </button>

        <button class="kb-today-btn" (click)="goToToday()" *ngIf="!isToday">
          <i class="pi pi-home"></i> Today
        </button>
      </div>

      <div class="kb-counters">
        <div class="kb-counter">
          <span class="kb-counter-val">{{ appointmentList.length }}</span>
          <span class="kb-counter-lbl">{{ selectedDate === today ? 'Total Today' : 'Total' }}</span>
        </div>
        <div class="kb-sep"></div>
        <div class="kb-counter accent-blue">
          <span class="kb-counter-val">{{ inProgressCount }}</span>
          <span class="kb-counter-lbl">In Progress</span>
        </div>
        <div class="kb-sep"></div>
        <div class="kb-counter accent-green">
          <span class="kb-counter-val">{{ getColumnCount('completed') }}</span>
          <span class="kb-counter-lbl">Completed</span>
        </div>
        <div class="kb-sep"></div>
        <div class="kb-counter accent-red">
          <span class="kb-counter-val">{{ getColumnCount('cancelled') }}</span>
          <span class="kb-counter-lbl">Cancelled</span>
        </div>
      </div>
    </div>

    <div class="kb-header-right">
      <!-- Search -->
      <div class="kb-search">
        <i class="pi pi-search"></i>
        <input
          type="text"
          placeholder="Search patient, doctor or type…"
          [(ngModel)]="searchTerm"
        />
        <button class="kb-search-clear" *ngIf="searchTerm" (click)="searchTerm = ''">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <!-- Add button -->
      <button class="kb-add-btn" (click)="openAddDialog()">
        <i class="pi pi-plus"></i>
        <span>Add Appointment</span>
      </button>

      <!-- Refresh -->
      <button
        class="kb-refresh-btn"
        (click)="refresh()"
        [disabled]="isLoading"
        [title]="'Last updated: ' + lastRefreshedLabel"
      >
        <i class="pi" [class.pi-refresh]="!isLoading" [class.pi-spin]="isLoading" [class.pi-spinner]="isLoading"></i>
      </button>
    </div>
  </div>

  <!-- ── Board ────────────────────────────────────────────────────── -->
  <div class="kb-board" *ngIf="!isLoading">
    <div
      class="kb-col"
      *ngFor="let col of kanbanColumns; trackBy: trackByColumn"
      [style.--col-accent]="col.accent"
      [style.--col-bg]="col.bg"
    >
      <div class="kb-col-head">
        <div class="kb-col-title">
          <span class="kb-col-icon"><i class="pi" [ngClass]="col.icon"></i></span>
          <span class="kb-col-name">{{ col.label }}</span>
        </div>
        <span class="kb-col-count" [class.kb-col-count--has]="getColumnCount(col.key) > 0">
          {{ getColumnCount(col.key) }}
        </span>
      </div>

      <div class="kb-col-body">
        <ng-container *ngIf="getColumnAppointments(col.key).length; else emptyCol">
          <div
            class="kb-card"
            [class.kb-card--asst-done]="isAssistantDone(appt)"
            *ngFor="let appt of getColumnAppointments(col.key); trackBy: trackByAppt"
          >
            <div class="kb-card-accent"></div>
            <div class="kb-card-inner">

              <!-- T1 · Identity ─────────────────── -->
              <p class="kb-patient">{{ appt.patient_name || 'Unknown' }}</p>
              <div class="kb-card-badges">
                <span class="kb-asst-done" *ngIf="isAssistantDone(appt)">
                  <i class="pi pi-check"></i> Seen
                </span>
                <span class="kb-type" [ngClass]="getTypeClass(appt.appointment_type)">
                  {{ appt.appointment_type || '—' }}
                </span>
                <span class="kb-mode" [ngClass]="getModeClass(appt.mode)">
                  {{ getModeLabel(appt.mode) }}
                </span>
              </div>
              <!-- divider -->
              <div class="kb-card-divider"></div>

              <!-- T2 · Schedule details ──────────── -->
              <div class="kb-card-meta">
                <span class="kb-meta-item">
                  <i class="pi pi-clock"></i>
                  {{ formatTime(appt.start_time) }}<ng-container *ngIf="appt.end_time"> – {{ formatTime(appt.end_time) }}</ng-container>
                </span>
                <span class="kb-meta-item" *ngIf="appt.doctor_name">
                  <i class="pi pi-user"></i>{{ appt.doctor_name }}
                </span>
              </div>

              <!-- T3 · Waiting badge ─────────────── -->
              <div class="kb-waiting" [ngClass]="getWaitTimeClass(getWaitingLabel(appt))" *ngIf="getWaitingLabel(appt) as wl">
                <i class="pi pi-hourglass"></i>{{ wl }}
              </div>

              <!-- T4 · Notes ─────────────────────── -->
              <div class="kb-card-notes" *ngIf="appt.notes">
                <i class="pi pi-align-left"></i>
                <span class="kb-notes-text">{{ appt.notes }}</span>
              </div>

              <!-- T5 · Tags footer ───────────────── -->
              <div class="kb-card-tags" *ngIf="appt.collectLater || appt.is_free">
                <span class="kb-tag kb-tag--mc" *ngIf="appt.collectLater">
                  <i class="pi pi-inbox"></i> Collect Later
                </span>
                <span class="kb-tag kb-tag--free" *ngIf="appt.is_free">Free</span>
              </div>

            </div>
          </div>
        </ng-container>

        <ng-template #emptyCol>
          <div class="kb-empty">
            <i class="pi pi-inbox"></i>
            <span>No appointments</span>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <!-- ── Skeletons ─────────────────────────────────────────────────── -->
  <div class="kb-loading" *ngIf="isLoading">
    <div class="kb-col kb-col--skeleton" *ngFor="let i of [1,2,3,4,5,6,7,8]">
      <p-skeleton width="100%" height="44px" styleClass="mb-3"></p-skeleton>
      <p-skeleton width="100%" height="88px" styleClass="mb-2"></p-skeleton>
      <p-skeleton width="100%" height="88px" styleClass="mb-2"></p-skeleton>
      <p-skeleton width="75%"  height="88px"></p-skeleton>
    </div>
  </div>

  <!-- ── Search empty state ────────────────────────────────────────── -->
  <div class="kb-no-results" *ngIf="!isLoading && searchTerm && !filteredList.length">
    <i class="pi pi-search"></i>
    <p>No appointments match <strong>"{{ searchTerm }}"</strong></p>
    <button class="kb-clear-search" (click)="searchTerm = ''">Clear search</button>
  </div>

</div>

<!-- ── Add Appointment Dialog ────────────────────────────────────────────── -->
<p-dialog
  [(visible)]="dialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  header="Add Appointment"
  [style]="{ width: '80vw', maxWidth: '960px' }"
  [contentStyle]="{ overflow: 'visible' }"
>
  <form class="appt-form" (ngSubmit)="saveAppointment()">

    <!-- Slot availability chips -->
    <div class="appt-form-meta">
      <p class="appt-form-hint">Select patient, type, date and time slot — all required fields.</p>
      <div class="appt-chips">
        <span class="appt-chip available"><i class="pi pi-check-circle"></i>{{ availableSlotsCount }} available</span>
        <span class="appt-chip blocked"><i class="pi pi-lock"></i>{{ blockedSlotsCount }} blocked</span>
      </div>
    </div>

    <!-- Fields -->
    <div class="appt-card">
      <div class="row">
        <!-- Patient search -->
        <div class="col-md-4 mb-3">
          <label class="appt-label">Patient <span class="req">*</span></label>
          <p-autoComplete
            [(ngModel)]="selectedPatient"
            name="patient"
            [suggestions]="patientList"
            (completeMethod)="searchPatients($event)"
            (onSelect)="onPatientSelect($event)"
            field="full_name"
            placeholder="Search by name or number"
            [forceSelection]="true"
            emptyMessage="No patients found"
            class="w-100"
          />
        </div>

        <!-- Appointment type -->
        <div class="col-md-4 mb-3">
          <label class="appt-label">Type <span class="req">*</span></label>
          <p-dropdown
            [(ngModel)]="appointment.appointment_type"
            name="appointment_type"
            [options]="typeOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Select type"
            class="w-100"
          />
        </div>

        <!-- Status -->
        <div class="col-md-4 mb-3">
          <label class="appt-label">Status <span class="req">*</span></label>
          <p-dropdown
            [(ngModel)]="appointment.status"
            name="status"
            [options]="statusOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Select status"
            class="w-100"
          />
        </div>

        <!-- Date -->
        <div class="col-md-4 mb-3">
          <label class="appt-label">Date <span class="req">*</span></label>
          <input
            type="date"
            class="form-control appt-date-input"
            name="appointment_date"
            [(ngModel)]="appointment.appointment_date"
            (change)="generateTimeSlots()"
          />
        </div>
      </div>

      <!-- Collect later toggle -->
      <div class="collect-later-wrap">
        <label class="collect-later-switch" for="collect_later_kb">
          <input
            class="collect-later-input"
            type="checkbox"
            id="collect_later_kb"
            name="collect_later"
            [(ngModel)]="appointment.collect_later"
          />
          <span class="collect-later-track" aria-hidden="true"></span>
          <span class="collect-later-copy">
            <span class="collect-later-title">Collect medicine later</span>
            <span class="collect-later-sub">Keep appointment flow unchanged, mark pickup for later.</span>
          </span>
        </label>
      </div>
    </div>

    <!-- Time slots -->
    <div class="appt-card">
      <label class="appt-label mb-2 d-block">Time Slot <span class="req">*</span></label>
      <div class="slot-grid">
        <button
          *ngFor="let slot of timeSlots"
          type="button"
          class="slot-btn"
          [class.selected]="selectedSlot === slot"
          [disabled]="slot.disabled"
          (click)="selectSlot(slot)"
        >
          {{ slot.label }}
        </button>
      </div>
    </div>

  </form>

  <ng-template pTemplate="footer">
    <div class="appt-footer">
      <button class="btn appt-cancel-btn" type="button" (click)="closeDialog()">
        <i class="pi pi-times"></i> Cancel
      </button>
      <button
        class="btn appt-save-btn"
        type="button"
        [disabled]="!canSave || isSaving"
        (click)="saveAppointment()"
      >
        <i class="pi" [class.pi-check]="!isSaving" [class.pi-spin]="isSaving" [class.pi-spinner]="isSaving"></i>
        {{ isSaving ? 'Saving…' : 'Add Appointment' }}
      </button>
    </div>
  </ng-template>
</p-dialog>
